webpackJsonp([122523174021968],{

/***/ 1396:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Miles Starkenburg","slug":"blog/author/miles-starkenburg","twitter":"gring0cl","linkedIn":null,"website":"","biography":"Miles is a Seattle-based Web Developer with emphasis in Ruby on Rails. He is passionate about leveraging technology to make a meaningful impact, and happiest when challenging himself to learn new skills and solve difficult problems.","image":{"fields":{"description":"blog-author-miles-starkenburg.jpg","file":{"url":"//images.ctfassets.net/k428n7s2pxlu/4ETaZr73ccIoMecsAGKa4w/db911b3d9f6367b01d11a17b2edc5346/blog-author-miles-starkenburg.jpg"}}}}},"pathContext":{"slug":"blog/author/miles-starkenburg"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-miles-starkenburg-3120bdee957afc551238.js